import React, { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SWEEPSTAKES_CONSTANTS } from '../core/Constants';

const SweepstakesDrawerContext = createContext();

export const useSweepstakesDrawer = () => {
  const context = useContext(SweepstakesDrawerContext);
  if (!context) {
    throw new Error('useSweepstakesDrawer must be used within a SweepstakesDrawerProvider');
  }
  return context;
};

const defaultDrawerState = {
  isOpen: false,
  drawerType: null,
  selectedStep: null,
  sweepstakesData: null,
};

export const SweepstakesDrawerProvider = ({ children }) => {
  const [drawerState, setDrawerState] = useState(defaultDrawerState);

  const openDrawer = (drawerType, options = {}) => {
    setDrawerState({
      isOpen: true,
      drawerType,
      selectedStep: options.selectedStep || null,
      sweepstakesData: options.sweepstakesData || null,
    });
  };

  const closeDrawer = () => {
    setDrawerState(defaultDrawerState);
  };

  const navigateToDrawer = (drawerType, options = {}) => {
    setDrawerState((prev) => ({
      ...prev,
      drawerType,
      selectedStep: options.selectedStep || null,
    }));
  };

  const contextValue = useMemo(() => ({
    drawerState,
    openDrawer,
    closeDrawer,
    navigateToDrawer,
    DRAWER_TYPES: SWEEPSTAKES_CONSTANTS.DRAWER_TYPES,
  }), [drawerState]);

  return (
    <SweepstakesDrawerContext.Provider value={contextValue}>
      {children}
    </SweepstakesDrawerContext.Provider>
  );
};

SweepstakesDrawerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};